import { Injectable } from '@angular/core';
import { Apollo, ApolloBase } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class GraphqlService {

  apollo: ApolloBase;
  legacyApollo: ApolloBase;
  imsApollo: ApolloBase;
  soapApollo: ApolloBase;
  vpmApollo: ApolloBase;
  vobApolloBase: ApolloBase;

  constructor(private apolloProvider: Apollo) {
    this.apollo = this.apolloProvider.use('vp');
    this.legacyApollo = this.apolloProvider.use('legacy');
    this.imsApollo = this.apolloProvider.use('ims');
    this.soapApollo = this.apolloProvider.use('soap');
    this.vpmApollo = this.apolloProvider.use('lvpm');
    this.vobApolloBase = this.apolloProvider.use('api/user');
  }
}
